import React from 'react';
import InView from 'react-intersection-observer';

export const DroneSoccerSimulator = () => {
  return (
    <section className="soccer-simulator-section">
      <div className="soccer-simulator-text">
        <div className="soccer-simulator-titles">
          <h2 className="soccer-simulator-subtitle">
            GAME-CHANGING & EDUCATIONAL
          </h2>
          <h3 className="soccer-simulator-title">DRONE SOCCER SOLUTIONS</h3>
        </div>
        <p className="soccer-simulator-description">
          Our one-of-a-kind simulator delivers structured, scenario-driven
          training to help students and teams hone their skills with precision.
        </p>
      </div>

      <div className="soccer-simulator-video-container">
        <InView triggerOnce>
          {({ ref, inView }) => (
            <video
              ref={ref}
              className="soccer-classroom-video"
              muted
              autoPlay
              loop={inView}
              playsInline
            >
              <source
                src="https://firebasestorage.googleapis.com/v0/b/website-orqafpv.firebasestorage.app/o/DroneSoccerSimulator.mp4?alt=media&token=db47b5a3-c30f-46ee-b238-58b0e34c344c"
                type="video/mp4"
              />
            </video>
          )}
        </InView>
      </div>
    </section>
  );
};
